import React, { Component } from 'react'
import Popup from './Popup'
import styled from 'styled-components'

import { LogeButtonSlim } from '../../GeneralStyle'
import { inject } from 'mobx-react';

import config from 'react-global-configuration';

@inject('userStore')
class PayInvoicePopup extends Component {

  render() {

    const invoices = this.props.userStore.invoices
    const company = this.props.userStore.company

    const vat = company.region ? company.region.country.taxrate : 0

    if(!invoices)
      return null

    const invoice = invoices.find(element => element.isPaid === false && element.gotRefunded === false && element.isRefund === false);

    if(!invoice)
      return null

    return (
      <Popup width="500px" height="auto" ref={instance => { this.child = instance; }} open={this.props.open}>
        <Heading>Offene Rechnung</Heading>

        <Text style={{marginTop: 20}}>
          Es gibt eine neue Rechnung in der Höhe von <i>€ { invoice.amount * ( 1 + vat ) }</i>,
          welche Sie in Ihrem Kontakt eMail Postfach finden können.
        </Text>

        { invoice.url &&
          <Text>
            Optional können Sie auch die <a href={config.get('CLOUDINARY_URL') + invoice.url} target="_blank" style={{cursor: "pointer", textDecoration: "underline"}}>Rechnung anzeigen</a>.
          </Text>
        }

        <Text style={{marginTop: 20}}>
          Bitte zahlen Sie die Rechnung so bald wie möglich.
        </Text>

        <Text style={{marginTop: 20}}><i>
          Hinweis: Nach Ihrer Zahlung kann es einige Tage benötigen, bis diese in unserem System aufscheint.
        </i></Text>

        <LogeButtonSlim
          hoverFontColor={"white"}
          style={{margin: "20px 0"}}
          onClick={() => { this.child.closeModal() }}>
            verstanden
        </LogeButtonSlim>
      </Popup>
    )
  }
}

export default PayInvoicePopup;

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`



// WEBPACK FOOTER //
// /src/components/internal/Popups/PayInvoicePopup.js